import { NgModule }      from "@angular/core";
import { TranslatePipe } from "../../shared/pipes/translate.pipe";
import { LocalDatePipe } from "../../shared/pipes/local-date.pipe";
import { CurrencyPipe } from "../../shared/pipes/currency.pipe";

const PIPES = [
	CurrencyPipe,
	LocalDatePipe,
	TranslatePipe
];

@NgModule({
	declarations: [
		...PIPES
	],
	imports: [],
	exports: [
		...PIPES
	]
})
export class PipesModule {
}
